import * as actions from "./tag.actions";
import * as api from "./tag.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./tag.constants";
import * as hooks from "./tag.hooks";
import * as promises from "./tag.promises";
import reducer from "./tag.reducer";
import { saga } from "./tag.saga";
import * as selectors from "./tag.selectors";
import * as utils from "./tag.utils";
export * from "./tag.types";
export var REDUCER_KEY_TAG = REDUCER_KEY;
export var tagModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
